import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { elakayAutoText as text } from "../../pageInside/dataElakay";

// Shows the message attached to a redirect into Provider Center (e.g. a Provider who opened a
// Seller-only page from an old link). Renders nothing otherwise.
export default function ProviderNotice() {
  const location = useLocation();
  const message = location.state?.providerNotice;
  const [dismissed, setDismissed] = useState(null);
  if (!message || dismissed === location.key) return null;
  return (
    <div className="pvc-notice" role="status">
      <i className="fas fa-info-circle" aria-hidden="true" />
      <p>{message}</p>
      <button type="button" onClick={() => setDismissed(location.key)} aria-label={text("h_pvc_notice_close", "Dismiss")}>×</button>
    </div>
  );
}
